module.exports = __webpack_public_path__ + "img/wales.02d01925.png";